module.exports = __webpack_public_path__ + "static/media/02.26371982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rank/02.jpg
// module id = 847
// module chunks = 0